module.exports = __webpack_public_path__ + "pc/static/img/fid.29c2ce07.png";